import { Tool } from '@procureai/agents';
import { useTranslation } from 'react-i18next';

import { ChatLoadingIndicator } from '../ChatMessage/indicators/ChatLoadingIndicator';
import { ChatToolResultIndicator } from '../ChatMessage/indicators/ChatToolResultIndicator';
import { I18nNamespace } from '~/common/types';

import { ToolResultComponent } from '.';

export const RunCheckQuoteRiskFromDemandTool: ToolResultComponent<
  Tool.runCheckQuoteRiskFromDemand,
  { fileIds: string[] },
  Record<string, unknown>
> = ({ tool }) => {
  // Note: for simplicity, we are reusing the same translation keys as runCheckQuoteRisk (otherwise use toolNames and add tarnslations)
  const { t } = useTranslation(I18nNamespace.intake, { keyPrefix: `Chat.tools.${Tool.runCheckQuoteRisk}` });
  switch (tool.state) {
    case 'input-streaming':
    case 'input-available':
      return <ChatLoadingIndicator message={t(`call`)} />;

    case 'output-available': {
      return <ChatToolResultIndicator message={t(`result`)} disabled={true} />;
    }
  }
};
